import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "feed-post flex w-full flex-col border-b-4 border-brand-dark-gray max-w-full" }
const _hoisted_2 = { class: "flex justify-between p-4 pt-8" }
const _hoisted_3 = { class: "flex flex-col my-auto overflow-hidden" }
const _hoisted_4 = { class: "flex flex-col space-y-1" }
const _hoisted_5 = { class: "text-white font-medium text-xl truncate" }
const _hoisted_6 = { class: "flex space-x-2.5 text-brand-light-gray w-full" }
const _hoisted_7 = { class: "flex space-x-1" }
const _hoisted_8 = { class: "my-auto text-xs line-clamp-1" }
const _hoisted_9 = { class: "text-xs my-auto min-w-max" }
const _hoisted_10 = ["id"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 1,
  class: "mx-4 mt-0 rounded-xl overflow-hidden border border-brand-darkish-gray"
}
const _hoisted_13 = {
  key: 2,
  class: "feed-post__video flex w-full relative"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 3,
  class: "feed-post__media-grid grid grid-rows-4 grid-cols-4 grid-flow-col gap-2 relative"
}
const _hoisted_16 = { class: "flex min-w-full h-full overflow-hidden" }
const _hoisted_17 = { class: "flex w-full relative" }
const _hoisted_18 = {
  key: 0,
  class: "flex absolute top-0 left-0 w-full h-full bg-brand-black/60 backdrop-blur z-20"
}
const _hoisted_19 = { class: "flex m-auto font-bold text-brand-lime" }
const _hoisted_20 = {
  key: 1,
  class: "w-full flex bg-brand-dark-gray"
}
const _hoisted_21 = {
  key: 2,
  class: "flex w-full"
}
const _hoisted_22 = ["onError", "src"]
const _hoisted_23 = { class: "flex border-brand-dark-gray justify-between" }
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = {
  key: 0,
  class: "fill-current w-5 h-5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_27 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-5 h-5"
}
const _hoisted_28 = { class: "text-sm pl-0 pr-4 text-brand-light-gray my-auto" }
const _hoisted_29 = {
  key: 0,
  class: "text-brand-light-gray text-sm px-2 my-auto"
}
const _hoisted_30 = {
  key: 0,
  class: "my-auto mr-4 bg-purple-500 text-white p-1 pt-1.5 px-2 rounded-full font-medium text-xxxs uppercase"
}
const _hoisted_31 = {
  key: 1,
  class: "my-auto mr-4 bg-brand-lime text-brand-black p-1 pt-1.5 px-2 font-medium rounded-full text-xxxs uppercase"
}

import {computed, nextTick, onBeforeUnmount, onMounted, onUnmounted, onUpdated, PropType, ref, watch} from "vue";
import {FeedPostInterface} from "@/interfaces/FeedPostInterface";
import {DateTime} from "luxon";
import pluralize from "pluralize"
import {isPlatform, modalController, useIonRouter} from "@ionic/vue";
import FeedPostContextMenu from "@/views/feed/FeedPostContextMenu.vue";
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {Swiper, SwiperSlide} from 'swiper/vue';
import UserVerificationCheck from "@/components/UserBadges.vue";
import * as sanitizeHtml from 'sanitize-html';
import FeedCommentContextMenu from "@/views/feed/FeedCommentContextMenu.vue";
import UsersList from "@/views/common/PostUsersList.vue";
import {PostPrivacy} from "@/definitions/PostPrivacy";
import {usePremium} from "@/composables/usePremium";
import {UserInterface} from "@/interfaces/UserInterface";
import UserAvatar from "@/components/UserAvatar.vue";
import {Haptics, ImpactStyle} from "@capacitor/haptics";
import {Preferences} from "@capacitor/preferences";
import {PreferenceKey} from "@/definitions/PreferenceKey";
import FeedPost from "@/components/FeedPost.vue";
import EventCard from "@/components/EventCard.vue";
import {EventTypeModel} from "@/definitions/EventTypeModel";
import {EventInterface} from "@/interfaces/EventInterface";
import Plyr from "plyr";
import {CapacitorVideoPlayer} from "capacitor-video-player";
import {useVerification} from "@/composables/useVerification";
import {useAppSettings} from "@/composables/useAppSettings";


export default /*@__PURE__*/_defineComponent({
  __name: 'FeedPost',
  props: {
  post: {
    type: Object as PropType<FeedPostInterface>,
    required: true
  },
  canViewUserProfile: {
    type: Boolean,
    default: true
  },
  authUser: {
    type: Object as PropType<UserInterface>,
    required: false
  },
},
  setup(__props) {


const props = __props

const appSettings = useAppSettings()
const enableNsfw = computed(() => appSettings.settings.value.enableNsfw !== false)

const postRef = ref(props.post)


const postedAt = computed(() => {
  const raw = props.post?.created_at
  if (!raw) return ''
  const dt = DateTime.fromISO(String(raw))
  return dt.isValid ? dt.toRelative() : ''
})

const totalComments = ref('')
const totalLikes = ref('')
const commentatorReacted = ref(false)
const observer = ref()


watch(() => props.post, post => {

  postRef.value = post

  const reactions = Array.isArray(post?.reactions) ? post.reactions : []
  const likes = reactions.map(reaction => {
    return reaction.count
  }).reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
  );
  totalLikes.value = !likes ? '' : `${likes} ${pluralize('like', likes)}`

  const reacted = reactions.filter(reaction => {
    return reaction.commentator_reacted
  })
  commentatorReacted.value = reacted.length > 0

  const comments = props.post?.count?.comments
  totalComments.value = !comments ? 'Comment' : `${comments} ${pluralize('comment', comments)}`


}, {deep: true, immediate: true})

const contextMenu = async () => {

  if (isPlatform('capacitor')) await Haptics.impact({style: ImpactStyle.Light});
  if (props.authUser && !props.authUser.id_verified) return await useVerification().presentVerificationRequired('You must be verified to flag posts or wink at users.')

  const sheet = await modalController.create({
    breakpoints: [0, 1],
    initialBreakpoint: 1,
    component: FeedPostContextMenu,
    componentProps: {
      post: props.post
    },
    mode: 'ios'
  })

  await sheet.present()

}

const like = async () => {
  try {

    if (isPlatform('capacitor')) await Haptics.impact({style: ImpactStyle.Light});
    if (props.authUser && !props.authUser.id_verified) return await useVerification().presentVerificationRequired('You must be verified to like posts.')

    if (commentatorReacted.value) {
      const reactions = Array.isArray(props.post.reactions) ? props.post.reactions : []
      postRef.value.reactions = reactions.map(reaction => {
        if (reaction.commentator_reacted) {
          reaction.commentator_reacted = false
          reaction.count--
        }
        return reaction
      }).filter(reaction => {
        return reaction.count > 0
      })

      return await ApiService.Feed().deletePostReaction(props.post.id)
    }
    if (!commentatorReacted.value) {
      if (!Array.isArray(postRef.value.reactions)) {
        postRef.value.reactions = []
      }
      postRef.value.reactions.push({
        commentator_reacted: true,
        count: 1,
        reaction: '❤️'
      })
      return await ApiService.Feed().postReaction(props.post.id)
    }

  } catch (e) {
    console.log('error')
    console.log(e)
  }
}

const swiperRef: any = ref()
const onSwiper = async (swiper: any) => {
  swiperRef.value = swiper
}

const swiperIndex = computed(() => {
  if (swiperRef.value) {
    return swiperRef.value.realIndex
  }
  return false
})


const ionRouter = useIonRouter()
const comment = async () => {
  ionRouter.navigate({
    name: 'FeedViewPost',
    params: {postId: props.post.id}
  }, 'forward', 'push')
}

const viewProfile = async () => {
  if (!props.canViewUserProfile) return

  ionRouter.navigate({
    name: 'PineappleFeedUserProfile',
    params: {
      userId: props.post?.posted_by.id
    }
  }, 'forward', 'push')
}

const postContent = computed(() => {
  return props.post?.data?.content || ''
})

const visibleMedia = computed(() => {
  const list = Array.isArray(props.post?.media) ? props.post.media : []
  return list.filter((m: any) => m && (m.url || m.thumbnail))
})

const mediaError = (media: any) => {
  media['error'] = true
}

const showLikedBy = async () => {
  if (!props.post?.comment_id) {
    return
  }

  const sheet = await modalController.create({
    breakpoints: [0, 1],
    initialBreakpoint: 1,
    component: UsersList,
    componentProps: {
      postId: props.post.comment_id
    },
    mode: 'ios'
  })
  await sheet.present()
  const { data } = await sheet.onDidDismiss()

  if (data?.user) {
    ionRouter.navigate({
      name: 'PineappleUserProfile',
      params: {
        userId: data.user.id
      }
    }, 'forward', 'push')
  }


}

const showXRated = ref(false)

const viewXRated = async (post: FeedPostInterface) => {

  if (post.media_type === "VIDEO" && !props.authUser?.subscribed) {
    return await usePremium().presentPayWall({
      text: `Upgrade to unlock NSFW video content.`,
    })
  }

  const dateFormat = 'd-MM-yyyy'
  const today = DateTime.now().toFormat(dateFormat)
  const dailyXRated = JSON.parse((await Preferences.get({key: PreferenceKey.DailyXRated})).value ?? '[]')
  const xRatedToday = dailyXRated.filter((record: string) => record === today)

  if (props.authUser?.id === post.posted_by.id || props.authUser?.subscribed || xRatedToday.length < 5) {
    dailyXRated.push(today)
    await Preferences.set({key: PreferenceKey.DailyXRated, value: JSON.stringify(dailyXRated)})
    return showXRated.value = true
  }

  await usePremium().presentPayWall({
    text: `You've reached your daily limit for NSFW photos. Upgrade to go unlimited.`,
  })

}

const handleClick = (event: any, link: any) => {
  event.preventDefault();

  if (link.getAttribute('target') === 'hashtag') {
    ionRouter.navigate({
      name: 'FeedHashtag',
      params: {
        tag: link.getAttribute('href')
      }
    }, 'forward', 'push')
  }

  if (link.getAttribute('target') === 'mention') {
    ionRouter.navigate({
      name: 'PineappleFeedUserProfile',
      params: {
        userId: link.getAttribute('href')
      }
    }, 'forward', 'push')
  }

  if (link.getAttribute('target') === '_system') {
    window.open(link.getAttribute('href'), '_system')
  }

};

const addClickListeners = () => {
  const container = document.getElementById('post' + props.post.id) as HTMLElement
  const links = container.querySelectorAll('a');
  links.forEach((link: any) => {
    link.addEventListener('click', (ev: any) => {
      handleClick(ev, link)
    });
  });
};

const removeClickListeners = () => {
  const container = document.getElementById('post' + props.post.id) as HTMLElement
  const links = container.querySelectorAll('a');
  links.forEach((link: any) => {
    link.removeEventListener('click', handleClick);
  });
};

// Mounted
onMounted(async () => {

  // if (isVideoPost.value) new Plyr(`#player${postRef.value.id}`, {
  //   controls: isPlatform('ios') ? ['play'] : ['play', 'fullscreen'],
  //   displayDuration: true,
  //   clickToPlay: true,
  //   autopause: true,
  //   hideControls: true,
  //   resetOnEnd: true
  // });

  observer.value = Observable.subscribe(async (response: any) => {
    if (props.post?.visibility === PostPrivacy.XRated) {
      if (response.event === ObservableEvent.FeedShowXRated) {
        showXRated.value = true
      }
      if (response.event === ObservableEvent.FeedHideXRated) {
        showXRated.value = false
      }
    }
  })

  addClickListeners();
})

onUnmounted(() => {
  observer.value?.unsubscribe()
})

onUpdated(async () => {
  const container = document.getElementById('post' + props.post.id) as HTMLElement
  const oldATags = container.querySelectorAll('a');
  oldATags.forEach((aTag: any) => {
    aTag.removeEventListener('click', handleClick);
  });

  addClickListeners()
})

onBeforeUnmount(() => {
  removeClickListeners()
})

const visibilityChanged = async (isVisible: any, entry: any) => {

  if (isVisible && props.post?.visibility === PostPrivacy.XRated) {
    const u = await ApiService.User().authUser()
    const shouldShowXRated = Boolean(Number(u.preferences[PreferenceKey.FeedShowXRated]))
    if (shouldShowXRated) {
      showXRated.value = true
    } else {
      showXRated.value = false
    }

  }
}

const viewEvent = async (event: EventInterface) => {
  ionRouter.navigate({
    name: 'FeedEvent',
    params: {
      eventId: event.id
    }
  }, 'forward', 'push')
}

const isVideoPost = computed(() => {
  return postRef.value.media_type === 'VIDEO' && visibleMedia.value.length > 0;
})

const player = ref()
const playVideo = async (url: string) => {

  if (!props.authUser?.subscribed) {
    return await usePremium().presentPayWall({
      text: `Upgrade to unlock NSFW video content.`,
    })
  }

  if (!isPlatform('capacitor')) {
    window.open(url, '_blank', 'noopener')
    return
  }

  const playerId = `player${postRef.value.id}`
  player.value = await CapacitorVideoPlayer.initPlayer({
    url: url,
    mode: 'fullscreen',
    playerId
  })

  await CapacitorVideoPlayer.play({
    playerId
  })

}


return (_ctx: any,_cache: any) => {
  const _component_photo_consumer = _resolveComponent("photo-consumer")!
  const _component_photo_provider = _resolveComponent("photo-provider")!
  const _directive_observe_visibility = _resolveDirective("observe-visibility")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: viewProfile,
        class: "flex overflow-hidden"
      }, [
        _createVNode(UserAvatar, {
          class: "mr-2 mb-auto",
          user: __props.post.posted_by
        }, null, 8, ["user"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(UserVerificationCheck, {
              class: "h-4",
              user: __props.post.posted_by
            }, null, 8, ["user"]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.post.posted_by?.name || 'Unknown'), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (__props.post.posted_by?.location?.name)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[5] || (_cache[5] = _createElementVNode("svg", {
                      class: "my-auto w-2.5 h-2.5 fill-current",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 384 512"
                    }, [
                      _createElementVNode("path", { d: "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" })
                    ], -1)),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(__props.post.posted_by.location.name), 1)
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "my-auto" }, "•", -1))
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, _toDisplayString(postedAt.value), 1)
          ])
        ])
      ]),
      _createElementVNode("div", {
        onClick: contextMenu,
        class: "flex ml-3 mt-0 mb-auto"
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("svg", {
          class: "my-auto",
          width: "24",
          height: "25",
          viewBox: "0 0 24 25",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            d: "M5.52035 14.5583C6.71329 14.5583 7.68035 13.5912 7.68035 12.3983C7.68035 11.2053 6.71329 10.2383 5.52035 10.2383C4.32742 10.2383 3.36035 11.2053 3.36035 12.3983C3.36035 13.5912 4.32742 14.5583 5.52035 14.5583Z",
            fill: "#A5A7AF"
          }),
          _createElementVNode("path", {
            d: "M12.0008 14.5583C13.1938 14.5583 14.1608 13.5912 14.1608 12.3983C14.1608 11.2053 13.1938 10.2383 12.0008 10.2383C10.8079 10.2383 9.84082 11.2053 9.84082 12.3983C9.84082 13.5912 10.8079 14.5583 12.0008 14.5583Z",
            fill: "#A5A7AF"
          }),
          _createElementVNode("path", {
            d: "M18.4803 14.5583C19.6732 14.5583 20.6403 13.5912 20.6403 12.3983C20.6403 11.2053 19.6732 10.2383 18.4803 10.2383C17.2874 10.2383 16.3203 11.2053 16.3203 12.3983C16.3203 13.5912 17.2874 14.5583 18.4803 14.5583Z",
            fill: "#A5A7AF"
          })
        ], -1)
      ]))])
    ]),
    _createElementVNode("div", {
      class: "flex w-full flex-col",
      id: 'post' + __props.post.id
    }, [
      (__props.post.data?.content)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([[
              `post-${__props.post.id}`
            ], "flex flex-col px-4 text-lg text-white pb-4 space-y-5 post-content"]),
            innerHTML: sanitizeHtml(postContent.value)
          }, null, 10, _hoisted_11))
        : _createCommentVNode("", true),
      (__props.post.type === _unref(EventTypeModel).Event)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(EventCard, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (viewEvent(__props.post.data.event as EventInterface))),
              "is-nested": true,
              event: __props.post.data.event as EventInterface
            }, null, 8, ["event"])
          ]))
        : _createCommentVNode("", true),
      (isVideoPost.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (enableNsfw.value && postRef.value.visibility === _unref(PostPrivacy).XRated && !showXRated.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (viewXRated(__props.post))),
                  class: "absolute flex top-0 left-0 w-full h-full z-40 bg-brand-black/10 backdrop-blur-xl"
                }, [...(_cache[8] || (_cache[8] = [
                  _createStaticVNode("<div class=\"absolute top-0 left-0 bg-brand-black w-full h-full z-10 opacity-50\" data-v-1ba2560e></div><div class=\"rounded-full flex flex-col m-auto px-16 items-center text-white z-50\" data-v-1ba2560e><svg class=\"w-3.5 fill-current text-white mb-2\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\" data-v-1ba2560e><path d=\"M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z\" data-v-1ba2560e></path></svg><div class=\"font-medium drop-shadow-lg text-xl\" data-v-1ba2560e>NSFW</div><div class=\"flex flex-col text items-center space-y-7\" data-v-1ba2560e><div class=\"flex flex-col\" data-v-1ba2560e><div class=\"drop-shadow-lg text-center\" data-v-1ba2560e>Not Safe For Work 😈</div></div><div class=\"flex space-x-1.5 text-white bg-brand-black rounded-full px-5 py-2 shadow-lg\" data-v-1ba2560e><div class=\"flex w-3 h-3 my-auto text-white\" data-v-1ba2560e><svg class=\"w-3 h-3 fill-current\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\" data-v-1ba2560e><path d=\"M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z\" data-v-1ba2560e></path></svg></div><div data-v-1ba2560e>Reveal</div></div></div></div>", 2)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (playVideo(postRef.value.media[0].url))),
              class: "flex z-20 relative w-full h-full"
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "absolute top-0 left-0 w-full h-full flex text-white z-40" }, [
                _createElementVNode("div", { class: "flex w-14 h-14 m-auto bg-brand-dark-gray/90 rounded-full" }, [
                  _createElementVNode("svg", {
                    class: "w-5 h-5 fill-current m-auto pl-1",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 384 512"
                  }, [
                    _createElementVNode("path", { d: "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z" })
                  ])
                ])
              ], -1)),
              _createElementVNode("img", {
                class: "w-full flex m-0 p-0 object-cover pointer-events-none",
                onError: _cache[2] || (_cache[2] = ($event: any) => (mediaError(postRef.value.media[0]))),
                src: postRef.value.media[0].thumbnail ?? postRef.value.media[0].url,
                alt: ""
              }, null, 40, _hoisted_14)
            ])
          ]))
        : _createCommentVNode("", true),
      (visibleMedia.value.length && !isVideoPost.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (enableNsfw.value && postRef.value.visibility === _unref(PostPrivacy).XRated && !showXRated.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (viewXRated(__props.post))),
                  class: "absolute flex top-0 left-0 w-full h-full z-40 bg-brand-black/10 backdrop-blur-xl"
                }, [...(_cache[10] || (_cache[10] = [
                  _createStaticVNode("<div class=\"absolute top-0 left-0 bg-brand-black w-full h-full z-10 opacity-50\" data-v-1ba2560e></div><div class=\"rounded-full flex flex-col m-auto px-16 items-center text-white z-50\" data-v-1ba2560e><svg class=\"w-3.5 fill-current text-white mb-2\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" data-v-1ba2560e><path d=\"M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z\" data-v-1ba2560e></path></svg><div class=\"font-medium drop-shadow-lg text-xl\" data-v-1ba2560e>NSFW</div><div class=\"flex flex-col text items-center space-y-7\" data-v-1ba2560e><div class=\"flex flex-col\" data-v-1ba2560e><div class=\"drop-shadow-lg text-center\" data-v-1ba2560e>Not Safe For Work 😈</div></div><div class=\"flex space-x-1.5 text-white bg-brand-black rounded-full px-5 py-2 shadow-lg\" data-v-1ba2560e><div class=\"flex w-3 h-3 my-auto text-white\" data-v-1ba2560e><svg class=\"w-3 h-3 fill-current\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\" data-v-1ba2560e><path d=\"M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z\" data-v-1ba2560e></path></svg></div><div data-v-1ba2560e>Reveal</div></div></div></div>", 2)
                ]))]))
              : _createCommentVNode("", true),
            _createVNode(_component_photo_provider, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleMedia.value, (media, mediaKey) => {
                  return (_openBlock(), _createBlock(_component_photo_consumer, {
                    key: mediaKey,
                    src: media.url,
                    class: _normalizeClass([{
                  '!col-span-4 !row-span-4' : visibleMedia.value.length === 1,
                  'col-span-2 row-span-4' : visibleMedia.value.length === 2,
                  'col-span-1 row-span-2' : visibleMedia.value.length === 3 && mediaKey !== 0,
                  '!col-span-2 !row-span-2' : visibleMedia.value.length === 4 ,
                  'col-span-3 row-span-4' : mediaKey === 0,
                  'col-span-3' : mediaKey !== 0,
                  '!hidden' : mediaKey > 4
                }, "w-full"])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          (mediaKey === 4)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, "+ " + _toDisplayString(visibleMedia.value.length - 4) + " more", 1)
                              ]))
                            : _createCommentVNode("", true),
                          (media.error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[11] || (_cache[11] = [
                                _createElementVNode("div", { class: "flex m-auto text-brand-light-gray px-8 text-center" }, [
                                  _createElementVNode("svg", {
                                    class: "w-14 h-14 fill-current",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 640 512"
                                  }, [
                                    _createElementVNode("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zm120 94.1c5.3-2 11.1-3.2 17.2-3.2c26.5 0 48 21.5 48 48c0 2-.1 4-.4 6L158.8 99.2zM328.1 231.9l20-29.4c4.5-6.6 11.9-10.5 19.8-10.5s15.4 3.9 19.8 10.5L499.4 366.1 328.1 231.9zM221.7 272.5c.3-.4 .6-.7 1-1.1L64 146.4V416c0 35.3 28.7 64 64 64H487.4l-81.2-64H320 248 152c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6l88-104z" })
                                  ])
                                ], -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (!media.error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("img", {
                                  class: "w-full flex m-0 p-0 object-cover pointer-events-none",
                                  onError: ($event: any) => (mediaError(media)),
                                  src: media.thumbnail ?? media.url
                                }, null, 40, _hoisted_22)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["src", "class"]))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_10),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", {
            onClick: like,
            class: _normalizeClass(["flex py-4 pl-4 pr-2", {
                            'text-red-500' : commentatorReacted.value,
                            'text-brand-light-gray' : !commentatorReacted.value,
                         }])
          }, [
            (totalLikes.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_26, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("path", { d: "M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" }, null, -1)
                ]))]))
              : _createCommentVNode("", true),
            (!totalLikes.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_27, [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ], 2),
          (totalLikes.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "flex my-auto h-full",
                onClick: showLikedBy
              }, [
                _createElementVNode("div", _hoisted_28, _toDisplayString(totalLikes.value), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (__props.post.allow_comments)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: comment,
              class: "flex py-4 text-brand-light-gray"
            }, [
              _cache[14] || (_cache[14] = _createElementVNode("svg", {
                class: "fill-current w-5 h-5",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", { d: "M4.913 2.658c2.075-.27 4.19-.408 6.337-.408 2.147 0 4.262.139 6.337.408 1.922.25 3.291 1.861 3.405 3.727a4.403 4.403 0 00-1.032-.211 50.89 50.89 0 00-8.42 0c-2.358.196-4.04 2.19-4.04 4.434v4.286a4.47 4.47 0 002.433 3.984L7.28 21.53A.75.75 0 016 21v-4.03a48.527 48.527 0 01-1.087-.128C2.905 16.58 1.5 14.833 1.5 12.862V6.638c0-1.97 1.405-3.718 3.413-3.979z" }),
                _createElementVNode("path", { d: "M15.75 7.5c-1.376 0-2.739.057-4.086.169C10.124 7.797 9 9.103 9 10.609v4.285c0 1.507 1.128 2.814 2.67 2.94 1.243.102 2.5.157 3.768.165l2.782 2.781a.75.75 0 001.28-.53v-2.39l.33-.026c1.542-.125 2.67-1.433 2.67-2.94v-4.286c0-1.505-1.125-2.811-2.664-2.94A49.392 49.392 0 0015.75 7.5z" })
              ], -1)),
              (totalComments.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(totalComments.value), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      (__props.post.visibility === 'INNER_CIRCLE')
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Inner Circle "))
        : _createCommentVNode("", true),
      (!__props.post.approved)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, " Pending Approval "))
        : _createCommentVNode("", true)
    ])
  ])), [
    [_directive_observe_visibility, visibilityChanged]
  ])
}
}

})